export function readTouchUTM() {
  try {
    const raw = localStorage.getItem("touch_utm");
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

// เซ็ตครั้งแรกเท่านั้น (ไม่ทับของเดิม)
export function setFirstTouchUTMFromURL() {
  const url = new URL(window.location.href);
  const utm = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']
    .reduce((acc,k)=>{ const v=url.searchParams.get(k); if(v) acc[k]=v; return acc; }, {});

  if (Object.keys(utm).length === 0) return; // ไม่มี UTM ใน URL ก็ข้าม

  const existed = readTouchUTM();
  if (!existed.utm_source && !existed.utm_medium && !existed.utm_campaign && !existed.utm_content && !existed.utm_term) {
    localStorage.setItem("touch_utm", JSON.stringify({ ...utm, ts: Date.now() }));
  }
}
// เซ็ตทับของเดิม
export function setLastTouchUTMFromURL() {
  const url = new URL(window.location.href);
  const utm = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']
    .reduce((acc,k)=>{ const v=url.searchParams.get(k); if(v) acc[k]=v.trim().toLowerCase(); return acc; }, {});
  if (Object.keys(utm).length === 0) return;
  localStorage.setItem("touch_utm", JSON.stringify({ ...utm, ts: Date.now(), model: "last-touch" }));
}

//เช็ค ทับเมื่อ “แตกต่างจากเดิม” หรือ “หมดอายุ”
export function setUTMFromURL_Smart({ ttlDays = 90 } = {}) {
  const url = new URL(window.location.href);
  const incoming = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']
    .reduce((acc,k)=>{ const v=url.searchParams.get(k); if(v) acc[k]=v.trim().toLowerCase(); return acc; }, {});
  if (Object.keys(incoming).length === 0) return;

  const existed = readTouchUTM();
  const expired = existed.ts ? (Date.now() - existed.ts) > ttlDays*24*60*60*1000 : true;

  const changed = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']
    .some(k => (incoming[k] || "") !== (existed[k] || ""));

  if (expired || changed) {
    localStorage.setItem("touch_utm", JSON.stringify({ ...incoming, ts: Date.now(), model: "smart" }));
  }
}

// (ทางเลือก) migrate ของเก่า ถ้าเคยเก็บเป็น key แยก ๆ มาก่อน
export function migrateLegacyUTMKeys() {
  const legacy = {
    utm_source: localStorage.getItem("utm_source"),
    utm_medium: localStorage.getItem("utm_medium"),
    utm_campaign: localStorage.getItem("utm_campaign"),
    utm_content: localStorage.getItem("utm_content"),
    utm_term: localStorage.getItem("utm_term"),
  };
  const hasLegacy = Object.values(legacy).some(Boolean);
  if (!hasLegacy) return;

  const existed = readTouchUTM();
  if (!existed.utm_source && !existed.utm_medium && !existed.utm_campaign && !existed.utm_content && !existed.utm_term) {
    localStorage.setItem("touch_utm", JSON.stringify({ ...legacy, ts: Date.now() }));
  }
}
